import router from '@/modules/FPKG-20000-Util/vueRouter';


const socket = (data: string) => {
  router.push('/login');
};
export default { socket };
